import { colors } from 'utils/themes/colors';

const textSizes = {
  overline: {
    fontSize: '0.625rem', // 10px
    lineHeight: 1.2, // 12px
  },
  extraSmall: {
    fontSize: '0.625rem', // 10px
    lineHeight: 1.4, // 14px
  },
  small: {
    fontSize: '0.75rem', // 12px
    lineHeight: 1.17, // 14px
  },
  base14: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.43, // 20px
  },
  base16: {
    fontSize: '1rem', // 16px
    lineHeight: 1.5, // 24px
  },
  large: {
    fontSize: '1.25rem', // 20px
    lineHeight: 1.4, // 28px
  },
  xLarge: {
    fontSize: '1.5rem', // 24px
    lineHeight: 1.34, // 32px
  },
  xxLarge: {
    fontSize: '1.875rem', // 30px
    lineHeight: 1.2, // 36px
  },
  xxxLarge: {
    fontSize: '2.25rem', // 36px
    lineHeight: 1.34, // 48px
  },
  smallHeadline: {
    fontSize: '2.625rem', // 42px
    lineHeight: 1.2, // 50px
  },
  headline: {
    fontSize: '3.75rem', // 60px
    lineHeight: 1.2, // 72px
  },
} as const;

const textWeights = {
  regular: {
    fontWeight: '400',
  },
  medium: {
    fontWeight: '500',
  },
  semiBold: {
    fontWeight: '600',
  },
  bold: {
    fontWeight: '700',
  },
} as const;

const textColors = {
  selected: {
    // TODO-THEME
    color: colors.accents.primary.base.default,
  },
  primary: {
    // TODO-THEME
    color: colors.texts.base,
  },
  secondary: {
    // TODO-THEME
    color: colors.texts.tint1,
  },
  tetriary: {
    // TODO-THEME
    color: colors.texts.tint2,
  },
  disabled: {
    // TODO-THEME
    color: colors.texts.tint2,
  },
  primary2: {
    // TODO-THEME
    color: colors.texts.negative,
  },
  selected2: {
    color: colors.statuses.information.base,
  },
  success: {
    // TODO-THEME
    color: colors.accents.primary.base.default,
  },
  brandSecondary: {
    // TODO-THEME
    color: colors.accents.secondary.base.default,
  },
  error: {
    // TODO-THEME
    color: colors.statuses.error.base,
  },
  warning: {
    // TODO-THEME
    color: colors.statuses.warning.base,
  },
  absoluteWhite: {
    // TODO-THEME
    color: colors.absolutes.white.base,
  },
} as const;

export type TextSizeProps = { size?: keyof typeof textSizes };
export type TextWeightProps = { weight?: keyof typeof textWeights };
export type TextColorProps = { color?: keyof typeof textColors };

const textSize = ({ size = 'overline' }: TextSizeProps) => textSizes[size];
const textWeight = ({ weight = 'regular' }: TextWeightProps) => textWeights[weight];
const textColor = ({ color = 'primary' }: TextColorProps) => textColors[color];

export {
  textSize,
  textWeight,
  textColor,
};
